/* eslint-disable no-empty-pattern */
import Box from '@material-ui/core/Box';
import LinearProgress from '@material-ui/core/LinearProgress';
import React from 'react';
import { BoxWrapper, ProgressWrapper, MultilineText, } from './OversightColumns.Styles';
import { MuiThemeProvider, createTheme, Tooltip } from '@material-ui/core';
import { isBaseURLAll } from '../../../../../api';
var theme = createTheme({
    palette: {
        primary: {
            main: '#2ECC40'
        },
        secondary: {
            main: '#FF4136'
        },
        success: {
            main: '#2ECC40'
        },
        error: {
            main: '#FF4136'
        }
    },
    overrides: {
        MuiTooltip: {
            tooltip: {
                fontSize: '1.1em'
            }
        }
    }
});
export var OversightColumns = [
    {
        headerName: 'Account Name',
        field: 'prjacc.name',
        hide: !isBaseURLAll(),
        width: 200
    },
    {
        field: 'Status',
        headerName: 'Status',
        width: 175
    },
    {
        field: 'ScheduleId',
        headerName: 'Schedule ID',
        width: 175,
        hide: true
    },
    {
        field: 'CampaignId',
        headerName: 'Campaign ID',
        width: 175,
        hide: true,
        cellRenderer: function (_a) {
            var _b, _c;
            var rowData = _a.data;
            return ((_b = rowData === null || rowData === void 0 ? void 0 : rowData.CampaignInfo) === null || _b === void 0 ? void 0 : _b.CampaignId) ? (_c = rowData === null || rowData === void 0 ? void 0 : rowData.CampaignInfo) === null || _c === void 0 ? void 0 : _c.CampaignId : 'Unavailable';
        }
    },
    {
        field: 'ScheduleExecutionId',
        headerName: 'Schedule Execution ID',
        hide: true,
        width: 250
    },
    {
        field: 'CampaignExecutionId',
        headerName: 'Campaign Execution ID',
        hide: true,
        width: 250,
        cellRenderer: function (_a) {
            var _b, _c;
            var rowData = _a.data;
            return ((_c = (_b = rowData === null || rowData === void 0 ? void 0 : rowData.ProgressInfo) === null || _b === void 0 ? void 0 : _b.CurrentSequenceInfo) === null || _c === void 0 ? void 0 : _c.CurrentCampaignExecutionId) || 'None';
        }
    },
    {
        field: 'StartTime',
        headerName: 'Start Time (UTC)',
        hide: true,
        width: 250,
        cellRenderer: function (_a) {
            var rowData = _a.data;
            return rowData === null || rowData === void 0 ? void 0 : rowData.StartTime;
        }
    },
    {
        field: 'EndTime',
        headerName: 'End Time (UTC)',
        hide: true,
        width: 250,
        cellRenderer: function (_a) {
            var rowData = _a.data;
            return rowData === null || rowData === void 0 ? void 0 : rowData.EndTime;
        }
    },
    {
        field: 'ScheduleName',
        headerName: 'Schedule Name',
        // pinned: 'left',
        width: 175
    },
    {
        field: 'CampaignName',
        headerName: 'Campaign Name',
        hide: true,
        width: 175,
        cellRenderer: function (_a) {
            var _b, _c;
            var rowData = _a.data;
            return ((_b = rowData === null || rowData === void 0 ? void 0 : rowData.CampaignInfo) === null || _b === void 0 ? void 0 : _b.CampaignName) ? (_c = rowData === null || rowData === void 0 ? void 0 : rowData.CampaignInfo) === null || _c === void 0 ? void 0 : _c.CampaignName : 'Unavailable';
        }
    },
    {
        field: 'CampaignMode',
        headerName: 'Campaign Mode',
        hide: true,
        width: 175,
        cellRenderer: function (_a) {
            var _b;
            var rowData = _a.data;
            var mode = (_b = rowData === null || rowData === void 0 ? void 0 : rowData.CampaignMode) === null || _b === void 0 ? void 0 : _b.toUpperCase();
            return mode != null ? mode : 'Unavailable';
        }
    },
    // {
    //   field: 'executionsSinceLastStatsReset',
    //   headerName: 'Total Campaign Calls',
    //   width: 175,
    //   cellRenderer: ({ data: rowData }) => {
    //     const totalCalls = rowData?.executionsSinceLastStatsReset;
    //     return (
    //       <MuiThemeProvider theme={theme}>
    //         <Tooltip title={rowData?.ScheduleName} placement='top'>
    //           <div>{totalCalls || 'N/A'}</div>
    //         </Tooltip>
    //       </MuiThemeProvider>
    //     );
    //   },
    // },
    {
        field: 'RecordsDialedProgress',
        headerName: 'Seq. Records Info',
        width: 175,
        cellRenderer: function (_a) {
            var _b;
            var rowData = _a.data;
            var sequenceProgress = (_b = rowData === null || rowData === void 0 ? void 0 : rowData.ProgressInfo) === null || _b === void 0 ? void 0 : _b.SequenceProgress;
            var recordsString;
            if (sequenceProgress &&
                sequenceProgress !== {} &&
                (sequenceProgress === null || sequenceProgress === void 0 ? void 0 : sequenceProgress.RecordsAttempted) != null &&
                (sequenceProgress === null || sequenceProgress === void 0 ? void 0 : sequenceProgress.RecordsToDial) != null)
                recordsString = (sequenceProgress === null || sequenceProgress === void 0 ? void 0 : sequenceProgress.RecordsAttempted) + " of " + (sequenceProgress === null || sequenceProgress === void 0 ? void 0 : sequenceProgress.RecordsToDial) + " Attempted";
            else if (sequenceProgress &&
                sequenceProgress !== {} &&
                (sequenceProgress === null || sequenceProgress === void 0 ? void 0 : sequenceProgress.RecordsAttempted) != null)
                recordsString = (sequenceProgress === null || sequenceProgress === void 0 ? void 0 : sequenceProgress.RecordsAttempted) + " Attempted";
            else
                recordsString = 'Not Available';
            return (React.createElement(MuiThemeProvider, { theme: theme },
                React.createElement(Tooltip, { title: rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleName, placement: 'top' },
                    React.createElement("div", null, recordsString))));
        }
    },
    {
        field: 'TotalSequencesRemaining',
        headerName: 'Sequences Remaining (Total)',
        hide: true,
        width: 225,
        cellRenderer: function (_a) {
            var _b;
            var rowData = _a.data;
            var progress = (_b = rowData === null || rowData === void 0 ? void 0 : rowData.ProgressInfo) === null || _b === void 0 ? void 0 : _b.ScheduleProgress;
            var progressCalculation = (progress === null || progress === void 0 ? void 0 : progress.TotalSequences) - (progress === null || progress === void 0 ? void 0 : progress.CurrentSequence);
            return (React.createElement(MuiThemeProvider, { theme: theme },
                React.createElement(Tooltip, { title: rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleName, placement: 'top' },
                    React.createElement("div", null, progressCalculation !== 0 ? progressCalculation : 'N/A'))));
        }
    },
    {
        field: 'TotalSequenceProgress',
        headerName: 'Sequence Progress (Total)',
        width: 375,
        cellRenderer: function (_a) {
            var _b;
            var rowData = _a.data;
            var progress = (_b = rowData === null || rowData === void 0 ? void 0 : rowData.ProgressInfo) === null || _b === void 0 ? void 0 : _b.ScheduleProgress;
            var progressCalculation = ((progress === null || progress === void 0 ? void 0 : progress.CurrentSequence) / (progress === null || progress === void 0 ? void 0 : progress.TotalSequences)) * 100;
            return (React.createElement(BoxWrapper, null,
                React.createElement(Box, { width: 7 / 10 },
                    React.createElement(ProgressWrapper, null,
                        React.createElement(MuiThemeProvider, { theme: theme },
                            React.createElement(Tooltip, { title: rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleName, placement: 'top' },
                                React.createElement(LinearProgress, { variant: 'determinate', value: progressCalculation, color: progressCalculation > 50 ? 'primary' : 'secondary' }))))),
                React.createElement(Box, { width: 3 / 10, style: { marginLeft: '1.5em' } },
                    React.createElement("b", null, progress === null || progress === void 0 ? void 0 :
                        progress.CurrentSequence,
                        " / ", progress === null || progress === void 0 ? void 0 :
                        progress.TotalSequences))));
        }
    },
    {
        field: 'CurrentSequenceName',
        headerName: 'Current Sequence',
        width: 175,
        cellRenderer: function (_a) {
            var _b, _c;
            var rowData = _a.data;
            var currentSeq = (_c = (_b = rowData === null || rowData === void 0 ? void 0 : rowData.ProgressInfo) === null || _b === void 0 ? void 0 : _b.CurrentSequenceInfo) === null || _c === void 0 ? void 0 : _c.CurrentSequenceName;
            return currentSeq ? currentSeq : 'Unavailable';
        }
    },
    {
        field: 'ActivePhoneTypes',
        headerName: 'Active Phone Types',
        hide: true,
        width: 250,
        cellRenderer: function (_a) {
            var _b, _c, _d;
            var rowData = _a.data;
            var activePhones = (_d = (_c = (_b = rowData === null || rowData === void 0 ? void 0 : rowData.ProgressInfo) === null || _b === void 0 ? void 0 : _b.CurrentSequenceInfo) === null || _c === void 0 ? void 0 : _c.ActivePhoneTypes) === null || _d === void 0 ? void 0 : _d.toString();
            return (React.createElement(MultilineText, null, activePhones != null ? activePhones : 'Unavailable'));
        }
    },
    {
        field: 'ActiveFilters',
        headerName: 'Active Filters',
        hide: true,
        width: 300,
        cellRenderer: function (_a) {
            var _b, _c, _d, _e;
            var rowData = _a.data;
            var filters = (_e = (_d = (_c = (_b = rowData === null || rowData === void 0 ? void 0 : rowData.ProgressInfo) === null || _b === void 0 ? void 0 : _b.CurrentSequenceInfo) === null || _c === void 0 ? void 0 : _c.Filters) === null || _d === void 0 ? void 0 : _d.map(function (f, i, arr) {
                if (i === 0)
                    return f.name;
                else if (i + 1 <= arr.length)
                    return " " + f.name;
            })) === null || _e === void 0 ? void 0 : _e.toString();
            return (React.createElement(MuiThemeProvider, { theme: theme },
                React.createElement(Tooltip, { title: rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleName, placement: 'top' },
                    React.createElement(MultilineText, null, filters != null ? filters : 'Unavailable'))));
        }
    },
    {
        field: 'CurrentSequenceProgress',
        headerName: 'Sequence Progress (Loop)',
        hide: true,
        width: 375,
        cellRenderer: function (_a) {
            var _b;
            var rowData = _a.data;
            var progress = (_b = rowData === null || rowData === void 0 ? void 0 : rowData.ProgressInfo) === null || _b === void 0 ? void 0 : _b.ScheduleProgress;
            var progressCalculation = ((progress === null || progress === void 0 ? void 0 : progress.CurrentSequenceIndex) / (progress === null || progress === void 0 ? void 0 : progress.NumSequences)) * 100;
            return (React.createElement(BoxWrapper, null,
                React.createElement(Box, { width: 7 / 10 },
                    React.createElement(ProgressWrapper, null,
                        React.createElement(MuiThemeProvider, { theme: theme },
                            React.createElement(Tooltip, { title: rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleName, placement: 'top' },
                                React.createElement(LinearProgress, { variant: 'determinate', value: progressCalculation, color: progressCalculation > 50 ? 'primary' : 'secondary' }))))),
                React.createElement(Box, { width: 3 / 10, style: { marginLeft: '1.5em' } },
                    React.createElement("b", null, progress === null || progress === void 0 ? void 0 :
                        progress.CurrentSequenceIndex,
                        " / ", progress === null || progress === void 0 ? void 0 :
                        progress.NumSequences))));
        }
    },
    {
        field: 'TotalLoopProgress',
        headerName: 'Loop Progress',
        hide: true,
        width: 375,
        cellRenderer: function (_a) {
            var _b;
            var rowData = _a.data;
            var progress = (_b = rowData === null || rowData === void 0 ? void 0 : rowData.ProgressInfo) === null || _b === void 0 ? void 0 : _b.ScheduleProgress;
            var progressCalculation = ((progress === null || progress === void 0 ? void 0 : progress.CurrentLoop) / (progress === null || progress === void 0 ? void 0 : progress.NumLoops)) * 100;
            return (React.createElement(BoxWrapper, null,
                React.createElement(Box, { width: 7 / 10 },
                    React.createElement(ProgressWrapper, null,
                        React.createElement(MuiThemeProvider, { theme: theme },
                            React.createElement(Tooltip, { title: rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleName, placement: 'top' },
                                React.createElement(LinearProgress, { variant: 'determinate', value: progressCalculation, color: progressCalculation > 50 ? 'primary' : 'secondary' }))))),
                React.createElement(Box, { width: 3 / 10, style: { marginLeft: '1.5em' } },
                    React.createElement("b", null, progress === null || progress === void 0 ? void 0 :
                        progress.CurrentLoop,
                        " / ", progress === null || progress === void 0 ? void 0 :
                        progress.NumLoops))));
        }
    },
    {
        field: 'LoopsRemaining',
        headerName: 'Loops Remaining',
        hide: true,
        width: 175,
        cellRenderer: function (_a) {
            var _b;
            var rowData = _a.data;
            var progress = (_b = rowData === null || rowData === void 0 ? void 0 : rowData.ProgressInfo) === null || _b === void 0 ? void 0 : _b.ScheduleProgress;
            var progressCalculation = (progress === null || progress === void 0 ? void 0 : progress.NumLoops) - (progress === null || progress === void 0 ? void 0 : progress.CurrentLoop);
            return (React.createElement(MuiThemeProvider, { theme: theme },
                React.createElement(Tooltip, { title: rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleName, placement: 'top' },
                    React.createElement("div", null, progressCalculation !== 0 ? progressCalculation : 'N/A'))));
        }
    },
    {
        field: 'ReservationsCreated',
        headerName: 'Reservations Created (Cumulative)',
        hide: true,
        width: 200,
        cellRenderer: function (_a) {
            var rowData = _a.data;
            var stats = rowData === null || rowData === void 0 ? void 0 : rowData.TaskQueueStats;
            return (React.createElement(MuiThemeProvider, { theme: theme },
                React.createElement(Tooltip, { title: rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleName, placement: 'top' },
                    React.createElement("div", null, stats === null || stats === void 0 ? void 0 : stats.ReservationsCreated))));
        }
    },
    {
        field: 'activeFlowExecutions',
        headerName: 'In-Flight Flow Executions',
        width: 200,
        cellRenderer: function (_a) {
            var rowData = _a.data;
            var activeFlowExecutions = rowData === null || rowData === void 0 ? void 0 : rowData.activeFlowExecutions;
            if (!activeFlowExecutions || activeFlowExecutions === {})
                activeFlowExecutions = 'Unavailable';
            return (React.createElement(MuiThemeProvider, { theme: theme },
                React.createElement(Tooltip, { title: rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleName, placement: 'top' },
                    React.createElement("div", null, activeFlowExecutions))));
        }
    },
    {
        field: 'availableWorkers',
        headerName: 'Available Workers',
        width: 175,
        cellRenderer: function (_a) {
            var rowData = _a.data;
            var stats = rowData === null || rowData === void 0 ? void 0 : rowData.TaskQueueStats;
            return (React.createElement(MuiThemeProvider, { theme: theme },
                React.createElement(Tooltip, { title: rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleName, placement: 'top' },
                    React.createElement("div", null, stats === null || stats === void 0 ? void 0 : stats.availableWorkers))));
        }
    },
    {
        field: 'unavailableWorkers',
        headerName: 'Unavailable Workers',
        width: 175,
        cellRenderer: function (_a) {
            var rowData = _a.data;
            var stats = rowData === null || rowData === void 0 ? void 0 : rowData.TaskQueueStats;
            var unavailableWorkers = stats === null || stats === void 0 ? void 0 : stats.unavailableWorkers;
            var breakWorkers = stats === null || stats === void 0 ? void 0 : stats.breakWorkers;
            var totalUnavailableWorkers = unavailableWorkers + breakWorkers;
            return (React.createElement(MuiThemeProvider, { theme: theme },
                React.createElement(Tooltip, { title: rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleName, placement: 'top' },
                    React.createElement("div", null, totalUnavailableWorkers != null
                        ? totalUnavailableWorkers
                        : 'Unavailable'))));
        }
    },
    {
        field: 'offlineWorkers',
        headerName: 'Offline Workers',
        hide: true,
        width: 175,
        cellRenderer: function (_a) {
            var rowData = _a.data;
            var stats = rowData === null || rowData === void 0 ? void 0 : rowData.TaskQueueStats;
            return (React.createElement(MuiThemeProvider, { theme: theme },
                React.createElement(Tooltip, { title: rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleName, placement: 'top' },
                    React.createElement("div", null, stats === null || stats === void 0 ? void 0 : stats.offlineWorkers))));
        }
    },
    {
        field: 'AbaTargetRate',
        headerName: 'ABA Target Rate',
        width: 175,
        cellRenderer: function (_a) {
            var rowData = _a.data;
            var pacing = rowData === null || rowData === void 0 ? void 0 : rowData.Pacing;
            return (React.createElement(MuiThemeProvider, { theme: theme },
                React.createElement(Tooltip, { title: rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleName, placement: 'top' },
                    React.createElement("div", null, (pacing === null || pacing === void 0 ? void 0 : pacing.AbaTargetRate) != null
                        ? (pacing === null || pacing === void 0 ? void 0 : pacing.AbaTargetRate.toFixed(2)) + " %"
                        : 'N/A'))));
        }
    },
    {
        field: 'last_abandon_rate',
        headerName: 'Last Abandon Rate',
        width: 175,
        cellRenderer: function (_a) {
            var _b, _c;
            var rowData = _a.data;
            var lastAbandonRate = (((_c = (_b = rowData === null || rowData === void 0 ? void 0 : rowData.ProgressInfo) === null || _b === void 0 ? void 0 : _b.SequenceProgress) === null || _c === void 0 ? void 0 : _c.LastAbandonRate) * 100).toFixed(2);
            return (React.createElement(MuiThemeProvider, { theme: theme },
                React.createElement(Tooltip, { title: rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleName, placement: 'top' },
                    React.createElement("div", null, lastAbandonRate != null ? lastAbandonRate + " %" : 'N/A'))));
        }
    },
    {
        field: 'AbandonRate_Calls',
        headerName: 'Abandon Rate Calls (Cumulative)',
        width: 225,
        cellRenderer: function (_a) {
            var rowData = _a.data;
            var stats = rowData === null || rowData === void 0 ? void 0 : rowData.TaskQueueStats;
            var abaRate = (stats === null || stats === void 0 ? void 0 : stats.AbandonRate_Calls) ? ((stats === null || stats === void 0 ? void 0 : stats.AbandonRate_Calls) * 100).toFixed(2)
                : stats === null || stats === void 0 ? void 0 : stats.AbandonRate_Calls;
            return (React.createElement(MuiThemeProvider, { theme: theme },
                React.createElement(Tooltip, { title: rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleName, placement: 'top' },
                    React.createElement("div", null, abaRate != null ? abaRate + " %" : 'N/A'))));
        }
    },
    {
        field: 'AbandonRate_Detects',
        headerName: 'Abandon Rate Detects (Cumulative)',
        width: 225,
        cellRenderer: function (_a) {
            var rowData = _a.data;
            var stats = rowData === null || rowData === void 0 ? void 0 : rowData.TaskQueueStats;
            var abaRate = (stats === null || stats === void 0 ? void 0 : stats.AbandonRate_Detects) ? ((stats === null || stats === void 0 ? void 0 : stats.AbandonRate_Detects) * 100).toFixed(2)
                : stats === null || stats === void 0 ? void 0 : stats.AbandonRate_Detects;
            return (React.createElement(MuiThemeProvider, { theme: theme },
                React.createElement(Tooltip, { title: rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleName, placement: 'top' },
                    React.createElement("div", null, abaRate != null ? abaRate + " %" : 'N/A'))));
        }
    },
    {
        field: 'AbandonRate_Connects',
        headerName: 'Abandon Rate Connects (Cumulative)',
        width: 225,
        cellRenderer: function (_a) {
            var _b;
            var rowData = _a.data;
            var stats = rowData === null || rowData === void 0 ? void 0 : rowData.TaskQueueStats;
            var abaRate = (stats === null || stats === void 0 ? void 0 : stats.AbandonRate_Connects) ? (_b = ((stats === null || stats === void 0 ? void 0 : stats.AbandonRate_Connects) * 100)) === null || _b === void 0 ? void 0 : _b.toFixed(2) : stats === null || stats === void 0 ? void 0 : stats.AbandonRate_Connects;
            return (React.createElement(MuiThemeProvider, { theme: theme },
                React.createElement(Tooltip, { title: rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleName, placement: 'top' },
                    React.createElement("div", null, abaRate != null ? abaRate + " %" : 'N/A'))));
        }
    },
    {
        field: 'tasks_canceled',
        headerName: 'Tasks Canceled (Cumulative)',
        width: 225,
        cellRenderer: function (_a) {
            var rowData = _a.data;
            var stats = rowData === null || rowData === void 0 ? void 0 : rowData.TaskQueueStats;
            return (React.createElement(MuiThemeProvider, { theme: theme },
                React.createElement(Tooltip, { title: rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleName, placement: 'top' },
                    React.createElement("div", null, stats === null || stats === void 0 ? void 0 : stats.tasks_canceled))));
        }
    },
    {
        field: 'tasks_entered',
        headerName: 'Tasks Entered (Cumulative)',
        width: 225,
        cellRenderer: function (_a) {
            var rowData = _a.data;
            var stats = rowData === null || rowData === void 0 ? void 0 : rowData.TaskQueueStats;
            return (React.createElement(MuiThemeProvider, { theme: theme },
                React.createElement(Tooltip, { title: rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleName, placement: 'top' },
                    React.createElement("div", null, stats === null || stats === void 0 ? void 0 : stats.tasks_entered))));
        }
    },
    {
        field: 'ABA Calculation',
        headerName: 'ABA Calculation',
        width: 175,
        cellRenderer: function (_a) {
            var rowData = _a.data;
            var pacing = rowData === null || rowData === void 0 ? void 0 : rowData.Pacing;
            return (React.createElement(MuiThemeProvider, { theme: theme },
                React.createElement(Tooltip, { title: rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleName, placement: 'top' },
                    React.createElement("div", null, pacing === null || pacing === void 0 ? void 0 : pacing.AbaCalculation))));
        }
    },
    {
        field: 'InitialCpa',
        headerName: 'Initial CPA',
        width: 175,
        cellRenderer: function (_a) {
            var rowData = _a.data;
            var pacing = rowData === null || rowData === void 0 ? void 0 : rowData.Pacing;
            return (React.createElement(MuiThemeProvider, { theme: theme },
                React.createElement(Tooltip, { title: rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleName, placement: 'top' },
                    React.createElement("div", null, pacing === null || pacing === void 0 ? void 0 : pacing.InitialCPA))));
        }
    },
    {
        field: 'InitialCPAMode',
        headerName: 'Initial CPA Mode',
        width: 175,
        cellRenderer: function (_a) {
            var rowData = _a.data;
            var pacing = rowData === null || rowData === void 0 ? void 0 : rowData.Pacing;
            return (React.createElement(MuiThemeProvider, { theme: theme },
                React.createElement(Tooltip, { title: rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleName, placement: 'top' },
                    React.createElement("div", null, pacing === null || pacing === void 0 ? void 0 : pacing.InitialCPAMode))));
        }
    },
    {
        field: 'InitialDuration',
        headerName: 'Initial Pacing',
        width: 175,
        cellRenderer: function (_a) {
            var rowData = _a.data;
            var pacing = rowData === null || rowData === void 0 ? void 0 : rowData.Pacing;
            return (React.createElement(MuiThemeProvider, { theme: theme },
                React.createElement(Tooltip, { title: rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleName, placement: 'top' },
                    React.createElement("div", null, pacing === null || pacing === void 0 ? void 0 : pacing.InitialDuration))));
        }
    },
    {
        field: 'AbaIncrement',
        headerName: 'ABA Increment',
        hide: true,
        width: 175,
        cellRenderer: function (_a) {
            var rowData = _a.data;
            var pacing = rowData === null || rowData === void 0 ? void 0 : rowData.Pacing;
            return (React.createElement(MuiThemeProvider, { theme: theme },
                React.createElement(Tooltip, { title: rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleName, placement: 'top' },
                    React.createElement("div", null, (pacing === null || pacing === void 0 ? void 0 : pacing.AbaIncrement) != null
                        ? (pacing === null || pacing === void 0 ? void 0 : pacing.AbaIncrement.toFixed(2)) + " %"
                        : 'N/A'))));
        }
    },
    {
        field: 'CpaModifier',
        headerName: 'CPA Modifier',
        hide: true,
        width: 175,
        cellRenderer: function (_a) {
            var rowData = _a.data;
            var pacing = rowData === null || rowData === void 0 ? void 0 : rowData.Pacing;
            return (React.createElement(MuiThemeProvider, { theme: theme },
                React.createElement(Tooltip, { title: rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleName, placement: 'top' },
                    React.createElement("div", null, (pacing === null || pacing === void 0 ? void 0 : pacing.CpaModifier) != null
                        ? (pacing === null || pacing === void 0 ? void 0 : pacing.CpaModifier.toFixed(2)) + " %"
                        : 'N/A'))));
        }
    },
    {
        field: 'ConcurrentCalls',
        headerName: 'Max Concurrent Calls',
        hide: true,
        width: 175,
        cellRenderer: function (_a) {
            var _b;
            var rowData = _a.data;
            var mode = (_b = rowData === null || rowData === void 0 ? void 0 : rowData.CampaignMode) === null || _b === void 0 ? void 0 : _b.toUpperCase();
            var pacing = rowData === null || rowData === void 0 ? void 0 : rowData.Pacing;
            return (React.createElement(MuiThemeProvider, { theme: theme },
                React.createElement(Tooltip, { title: rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleName, placement: 'top' },
                    React.createElement("div", null, mode === 'AGENTLESS' ? pacing === null || pacing === void 0 ? void 0 : pacing.ConcurrentCalls : 'N/A'))));
        }
    },
    {
        field: 'Weight',
        headerName: 'Campaign Priority',
        hide: true,
        width: 175,
        cellRenderer: function (_a) {
            var rowData = _a.data;
            return (React.createElement(MuiThemeProvider, { theme: theme },
                React.createElement(Tooltip, { title: rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleName, placement: 'top' },
                    React.createElement("div", null, rowData === null || rowData === void 0 ? void 0 : rowData.CampaignWeight))));
        }
    },
    {
        field: 'reservations_accepted',
        headerName: 'Reservations Accepted (Cumulative)',
        hide: true,
        width: 230,
        cellRenderer: function (_a) {
            var rowData = _a.data;
            var stats = rowData === null || rowData === void 0 ? void 0 : rowData.TaskQueueStats;
            return (React.createElement(MuiThemeProvider, { theme: theme },
                React.createElement(Tooltip, { title: rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleName, placement: 'top' },
                    React.createElement("div", null, stats === null || stats === void 0 ? void 0 : stats.reservations_accepted))));
        }
    },
    {
        field: 'TasksReservedRealTime',
        headerName: 'Tasks Reserved',
        hide: true,
        width: 175,
        cellRenderer: function (_a) {
            var _b;
            var rowData = _a.data;
            var tasksByStatus = (_b = rowData === null || rowData === void 0 ? void 0 : rowData.TaskQueueStats) === null || _b === void 0 ? void 0 : _b.tasks_by_status;
            var tasksReserved = (tasksByStatus === null || tasksByStatus === void 0 ? void 0 : tasksByStatus.reserved) != null
                ? tasksByStatus === null || tasksByStatus === void 0 ? void 0 : tasksByStatus.reserved : 'Unavailable';
            return (React.createElement(MuiThemeProvider, { theme: theme },
                React.createElement(Tooltip, { title: rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleName, placement: 'top' },
                    React.createElement("div", null, tasksByStatus !== {} ? tasksReserved : 'Unavailable'))));
        }
    },
    {
        field: 'TasksCompletedRealTime',
        headerName: 'Tasks Completed',
        hide: true,
        width: 175,
        cellRenderer: function (_a) {
            var _b;
            var rowData = _a.data;
            var tasksByStatus = (_b = rowData === null || rowData === void 0 ? void 0 : rowData.TaskQueueStats) === null || _b === void 0 ? void 0 : _b.tasks_by_status;
            var tasksCompleted = (tasksByStatus === null || tasksByStatus === void 0 ? void 0 : tasksByStatus.completed) != null
                ? tasksByStatus === null || tasksByStatus === void 0 ? void 0 : tasksByStatus.completed : 'Unavailable';
            return (React.createElement(MuiThemeProvider, { theme: theme },
                React.createElement(Tooltip, { title: rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleName, placement: 'top' },
                    React.createElement("div", null, tasksByStatus !== {} ? tasksCompleted : 'Unavailable'))));
        }
    },
    {
        field: 'TasksWrappingRealTime',
        headerName: 'Tasks Wrapping',
        hide: true,
        width: 175,
        cellRenderer: function (_a) {
            var _b;
            var rowData = _a.data;
            var tasksByStatus = (_b = rowData === null || rowData === void 0 ? void 0 : rowData.TaskQueueStats) === null || _b === void 0 ? void 0 : _b.tasks_by_status;
            var tasksWrapping = (tasksByStatus === null || tasksByStatus === void 0 ? void 0 : tasksByStatus.wrapping) != null
                ? tasksByStatus === null || tasksByStatus === void 0 ? void 0 : tasksByStatus.wrapping : 'Unavailable';
            return (React.createElement(MuiThemeProvider, { theme: theme },
                React.createElement(Tooltip, { title: rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleName, placement: 'top' },
                    React.createElement("div", null, tasksByStatus !== {} ? tasksWrapping : 'Unavailable'))));
        }
    },
    {
        field: 'TasksAssignedRealTime',
        headerName: 'Tasks Assigned',
        hide: true,
        width: 175,
        cellRenderer: function (_a) {
            var _b;
            var rowData = _a.data;
            var tasksByStatus = (_b = rowData === null || rowData === void 0 ? void 0 : rowData.TaskQueueStats) === null || _b === void 0 ? void 0 : _b.tasks_by_status;
            var tasksAssigned = (tasksByStatus === null || tasksByStatus === void 0 ? void 0 : tasksByStatus.assigned) != null
                ? tasksByStatus === null || tasksByStatus === void 0 ? void 0 : tasksByStatus.assigned : 'Unavailable';
            return (React.createElement(MuiThemeProvider, { theme: theme },
                React.createElement(Tooltip, { title: rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleName, placement: 'top' },
                    React.createElement("div", null, tasksByStatus !== {} ? tasksAssigned : 'Unavailable'))));
        }
    },
    {
        field: 'TasksCanceledRealTime',
        headerName: 'Tasks Canceled',
        hide: true,
        width: 175,
        cellRenderer: function (_a) {
            var _b;
            var rowData = _a.data;
            var tasksByStatus = (_b = rowData === null || rowData === void 0 ? void 0 : rowData.TaskQueueStats) === null || _b === void 0 ? void 0 : _b.tasks_by_status;
            var tasksCanceled = (tasksByStatus === null || tasksByStatus === void 0 ? void 0 : tasksByStatus.canceled) != null
                ? tasksByStatus === null || tasksByStatus === void 0 ? void 0 : tasksByStatus.canceled : 'Unavailable';
            return (React.createElement(MuiThemeProvider, { theme: theme },
                React.createElement(Tooltip, { title: rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleName, placement: 'top' },
                    React.createElement("div", null, tasksByStatus !== {} ? tasksCanceled : 'Unavailable'))));
        }
    },
    {
        field: 'TasksPendingRealTime',
        headerName: 'Tasks Pending',
        hide: true,
        width: 175,
        cellRenderer: function (_a) {
            var _b;
            var rowData = _a.data;
            var tasksByStatus = (_b = rowData === null || rowData === void 0 ? void 0 : rowData.TaskQueueStats) === null || _b === void 0 ? void 0 : _b.tasks_by_status;
            var tasksPending = (tasksByStatus === null || tasksByStatus === void 0 ? void 0 : tasksByStatus.pending) != null ? tasksByStatus === null || tasksByStatus === void 0 ? void 0 : tasksByStatus.pending : 'Unavailable';
            return (React.createElement(MuiThemeProvider, { theme: theme },
                React.createElement(Tooltip, { title: rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleName, placement: 'top' },
                    React.createElement("div", null, tasksByStatus !== {} ? tasksPending : 'Unavailable'))));
        }
    },
    {
        field: 'TaskQueue',
        headerName: 'Task Queue',
        hide: true,
        width: 175,
        cellRenderer: function (_a) {
            var _b;
            var rowData = _a.data;
            var taskQueueName = (_b = rowData === null || rowData === void 0 ? void 0 : rowData.TaskQueueStats) === null || _b === void 0 ? void 0 : _b.taskQueueName;
            return (React.createElement("div", null, taskQueueName != null ? taskQueueName : 'Not Available'));
        }
    },
    {
        field: 'StudioFlow',
        headerName: 'StudioFlow',
        width: 350,
        cellRenderer: function (_a) {
            var _b, _c;
            var rowData = _a.data;
            return ((_b = rowData === null || rowData === void 0 ? void 0 : rowData.CampaignInfo) === null || _b === void 0 ? void 0 : _b.StudioFlowSid) ? (_c = rowData === null || rowData === void 0 ? void 0 : rowData.CampaignInfo) === null || _c === void 0 ? void 0 : _c.StudioFlowSid : 'Unavailable';
        },
        hide: true
    },
];
//# sourceMappingURL=OversightColumns.js.map